import ArtistProfile from "../components/Profile/ArtistProfile";
import PageWrapper from "../components/UI/PageWrapper";

const ProfilePage = () => (
  <PageWrapper>
    {/* <div className="mx-auto p-12 text-black rounded-lg profile-form flex flex-col gap-[2.875rem] min-h-screen">
      <h1 className="profile-info-text-size">Profile Info</h1>

    </div> */}
    <ArtistProfile />
  </PageWrapper>
);

export default ProfilePage;
